import classNames from 'classnames';
import type { ComponentProps, FC, PropsWithChildren } from 'react';

const ContainerWithBorder: FC<
  PropsWithChildren<
    ComponentProps<'div'> & {
      containerClassName?: string;
      innerWrapperClassName?: string;
    }
  >
> = ({ children, innerWrapperClassName, containerClassName }) => (
  <div className={classNames(containerClassName)}>
    <div
      className={classNames('w-full bg-white h-full', innerWrapperClassName)}
    >
      {children}
    </div>
  </div>
);

export default ContainerWithBorder;
